import format from "comma-number";
import useSWR from "swr";
import fetcher from "~/lib/fetcher";

export function ViewCounter({ blogUrl, slug }) {
  const { data } = useSWR(`/api/${blogUrl}/${blogUrl}/${slug}`, fetcher);
  const views = data?.total;
  return <>{views != null ? format(views) : "–––"} views</>;
}
